module.exports = __webpack_public_path__ + "img/Best Practices_Joenel Lacaden.e06a1bed.jpg";